import Accordion from 'accordion-js';

class StoreAccordion extends HTMLElement {
  connectedCallback() {

    new Accordion(this, {
      elementClass: 'store-accordion__inner',
      triggerClass: 'store-accordion__toggle',
      panelClass: 'store-accordion__panel',
      onlyChildNodes: false,
      duration: 300,
      beforeOpen: (currentElement) => {
        currentElement.querySelector('.store-accordion__toggle-icon').classList.add('is-active');
      },
      beforeClose: (currentElement) => {
        currentElement.querySelector('.store-accordion__toggle-icon').classList.remove('is-active');
      },
    });
  }
}

customElements.define('store-accordion', StoreAccordion);

